import DOMPurify from "dompurify";

const POLICY_TAGS = [
  "p",
  "br",
  "span",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ul",
  "ol",
  "li",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];

export const sanitizePolicyHtml = (policy) =>
  DOMPurify.sanitize(String(policy || ""), {
    ALLOWED_TAGS: POLICY_TAGS,
    ALLOWED_ATTR: ["href", "style", "title"],
  });
